import React from 'react';
import styled from 'styled-components';

interface Props {
  children: any;
}

const StyledDiv = styled.div`
  font-weight: bold;
  display: block;
  font-size: 12px;
  margin-bottom: 8px;
`;

export const AutoMessageTitle = (props: Props) => {
  const { children } = props;
  return <StyledDiv>{children}</StyledDiv>;
};
